import React from 'react';
import Layout from '../layout';
import BookDemoSectionOne from '../components/Esper/ContactUs/BookDemoSectionOne';
import PartnerSection from '../components/Esper/OurPartnersContactUs';
import { BottomBanner } from '../components/Esper/BottomBanner';
import messages from '../i18n/en';

export default (props: any) => (
  <Layout
    messages={messages}
    title={'Contact Us | Esper'}
    description={`Contact Esper, a smarter platform for Android DevOps and advanced MDM/EMM. Start a conversation about Android device management via phone or email. `}
    keywords={`android kiosk mode, kiosk app android,remote management, mdm, mdm solutions`}
    className="first-page"
    location={props.location}
  >
    <BookDemoSectionOne messages={messages} />
    <PartnerSection
      messages={messages}
      companies={['android', 'lenovo', 'zebra', 'mediatek']}
      title={`You’re in good company, Our Partners `}
    />
    <BottomBanner
      buttonText={'See Current Openings'}
      description={
        'Let’s build a fantastic team, have fun, and change the world together!'
      }
      link={`/careers#current-openings`}
    />
  </Layout>
);
